import {isNil} from 'lodash';

/**
 * Generates a callback that returns a React Component
 *
 * @param {object} params - Parameters
 * @param {function} params.component - A React Component to be returned in the callback
 *
 * @returns {function} - Callback - A function that returns a React Component
 */
// export function generateComponentCallback({component}: any) {
//   return () => component;
// }
export function generateComponentCallback({
  component,
}: {
  component: React.ReactNode;
}) {
  return () => component;
}

/**
 * Generates a callback to be called when info icon is pressed, sends tealium tracking and onInfoIconPress callback
 *
 * @param {object} params - Parameters
 * @param {function} params.func - A function to be called in the callback
 * @param {object | number | string |  null} params.params - The params to pass into the function that will be called
 *
 * @returns {function} - Callback - A function to be called when tab is pressed
 */
export function generateCallback({func, params}: any) {
  if (!isNil(params)) {
    return () => {
      func(params);
    };
  }
  return () => {
    func();
  };
}

/**
 * Generates a callback that calls all of the functions that are passed in with included params
 *
 * @param {array} functions - An array of objects { func, params } that contain a function to be called and its params
 *
 * @returns {function} - Callback - A function that calls all the functions passed in
 */
export function generateCallbacks(functions: any) {
  return () => {
    functions.forEach(({func, params}: any) =>
      generateCallback({func, params})(),
    );
  };
}
